export const WF_SO_FORM_FIELDS = [
    {
        label: 'Product Table',
        sectionCode: 'labels_table',
        fields: [
            {
                settingFieldName: 'item',
                formFieldname: 'item'
            },
            {
                settingFieldName: 'description',
                formFieldname: 'description'
            },
            // {
            //     settingFieldName: 'bin',
            //     formFieldname: 'bin'
            // },
            {
                settingFieldName: 'qty',
                formFieldname: 'qty'
            },
            {
                settingFieldName: 'uom',
                formFieldname: 'uom'
            },
            {
                settingFieldName: 'rate',
                formFieldname: 'rate'
            },
            {
                settingFieldName: 'totalamount',
                formFieldname: 'totalamount'
            },
            {
                settingFieldName: 'tbldiscount',
                formFieldname: 'tbldiscount'
            },
            {
                settingFieldName: 'tbltax',
                formFieldname: 'tbltax'
            },
            {
                settingFieldName: 'handlingfee',
                formFieldname: 'table_handlingfee'
            },
            {
                settingFieldName: 'amount',
                formFieldname: 'amount'
            }
        ]
    },
    {
        label: 'Payments',
        sectionCode: 'labels_section',
        fields: [
            {
                settingFieldName: 'payment term',
                formFieldname: 'paymentterm'
            },
            {
                settingFieldName: 'payment method',
                formFieldname: 'paymentmethod'
            },
            {
                settingFieldName: 'shippingterm',
                formFieldname: 'shippingterm'
            },
            {
                settingFieldName: 'shippingmethod',
                formFieldname: 'shippingmethod'
            },
            {
                settingFieldName: 'salesrep',
                formFieldname: 'salesrep'
            }
        ]
    },
    {
        label: 'Table Footer',
        sectionCode: 'labels_footer',
        fields: [
            {
                settingFieldName: 'subtotal',
                formFieldname: 'subtotal'
            },
            {
                settingFieldName: 'discount',
                formFieldname: 'discount'
            },
            {
                settingFieldName: 'tax',
                formFieldname: 'tax'
            },
            {
                settingFieldName: 'handlingfee',
                formFieldname: 'handlingfee'
            },
            {
                settingFieldName: 'adddiscount',
                formFieldname: 'adddiscount'
            },
            {
                settingFieldName: 'shipping',
                formFieldname: 'shipping'
            },
            {
                settingFieldName: 'order total',
                formFieldname: 'ordertotal'
            },
            {
                settingFieldName: 'freeshipping',
                formFieldname: 'freeshipping'
            }
        ]
    }
];

export const WF_SO_UPDATE_FIELDS = [
    {
        label: 'Misc',
        sectionCode: 'labels_misc',
        fields: [
            {
                settingFieldName: 'date',
                formFieldname: 'date'
            },
            {
                settingFieldName: 'duedate',
                formFieldname: 'duedate'
            },
            {
                settingFieldName: 'status',
                formFieldname: 'status'
            }
        ]
    },
    {
        label: 'Term',
        sectionCode: 'labels_section',
        fields: [
            {
                settingFieldName: 'shippingterm',
                formFieldname: 'shippingterm'
            },
            {
                settingFieldName: 'shippingmethod',
                formFieldname: 'shippingmethod'
            },
            {
                settingFieldName: 'salesrep',
                formFieldname: 'salesrep'
            }
        ]
    },
    {
        label: 'Message',
        sectionCode: 'labels_message',
        fields: [
            {
                settingFieldName: 'vendormessage',
                formFieldname: 'vendormessage'
            },
            {
                settingFieldName: 'memo',
                formFieldname: 'memo'
            }
        ]
    },
    {
        label: 'Footer',
        sectionCode: 'labels_footer',
        fields: [
            {
                settingFieldName: 'freeshipping',
                formFieldname: 'freeshipping'
            },
            {
                settingFieldName: 'shipping',
                formFieldname: 'shipping'
            },

        ]
    }
];

export const WF_IN_PRODUCT_UPDATE_FIELDS = [
    {
        label: 'Items',
        sectionCode: 'labels_item',
        fields: [
            {
                settingFieldName: 'variant',
                formFieldname: 'variant'
            },
            {
                settingFieldName: 'category',
                formFieldname: 'category'
            },
            {
                settingFieldName: 'uom',
                formFieldname: 'uom'
            },
            {
                settingFieldName: 'color',
                formFieldname: 'color'
            }
        ]
    },
    {
        label: 'Item Attributes',
        sectionCode: 'labels_attributes',
        fields: [
            {
                settingFieldName: 'hsn',
                formFieldname: 'hsn'
            },
            {
                settingFieldName: 'width',
                formFieldname: 'width'
            },
            {
                settingFieldName: 'height',
                formFieldname: 'height'
            },
            {
                settingFieldName: 'lwhuom',
                formFieldname: 'lwhuom'
            },
            {
                settingFieldName: 'weight',
                formFieldname: 'weight'
            },
            {
                settingFieldName: 'wuom',
                formFieldname: 'wuom'
            },
            {
                settingFieldName: 'vendor',
                formFieldname: 'vendor'
            },
            {
                settingFieldName: 'vendorsku',
                formFieldname: 'vendorsku'
            },
            {
                settingFieldName: 'brand',
                formFieldname: 'brand'
            },
            {
                settingFieldName: 'manufacturer',
                formFieldname: 'manufacturer'
            },
            {
                settingFieldName: 'manufacturercountry',
                formFieldname: 'manufacturercountry'
            },
            {
                settingFieldName: 'warranty',
                formFieldname: 'warranty'
            },
            {
                settingFieldName: 'txtwarranty',
                formFieldname: 'txtwarranty'
            }
        ]
    },
    {
        label: 'Purchase Sales Info',
        sectionCode: 'labels_purchasesales',
        fields: [
            {
                settingFieldName: 'cost',
                formFieldname: 'cost'
            },
            {
                settingFieldName: 'price',
                formFieldname: 'price'
            },
            {
                settingFieldName: 'cogs',
                formFieldname: 'cogs'
            },
            {
                settingFieldName: 'income',
                formFieldname: 'income'
            },
            {
                settingFieldName: 'asset',
                formFieldname: 'asset'
            },
            {
                settingFieldName: 'class',
                formFieldname: 'class'
            }
        ]
    },
    {
        label: 'Warehouse Info',
        sectionCode: 'labels_warehouse',
        fields: [
            {
                settingFieldName: 'reorderqty',
                formFieldname: 'reorderqty'
            },
            {
                settingFieldName: 'maxqty',
                formFieldname: 'maxqty'
            },
            {
                settingFieldName: 'prefStock',
                formFieldname: 'prefStock'
            },
            {
                settingFieldName: 'minQty',
                formFieldname: 'minQty'
            }
        ]
    },
    {
        label: 'Other 1',
        sectionCode: 'labels_inv_other1',
        fields: []
    },
    {
        label: 'Other 2',
        sectionCode: 'labels_inv_other2',
        fields: []
    },
    {
        label: 'Other 3',
        sectionCode: 'labels_inv_other3',
        fields: []
    }

];

export const WF_SERVICE_PRODUCT_UPDATE_FIELDS = [
    {
        label: "Service Items",
        sectionCode: "labels_service",
        fields: [
            {
                settingFieldName: 'variant',
                formFieldname: 'variant'
            },
            {
                settingFieldName: 'category',
                formFieldname: 'category'
            },
            {
                settingFieldName: 'uom',
                formFieldname: 'uom'
            },
            {
                settingFieldName: 'cost',
                formFieldname: 'cost'
            },
            {
                settingFieldName: 'saleprice',
                formFieldname: 'saleprice'
            },
            {
                settingFieldName: 'rate',
                formFieldname: 'rate'
            },
            {
                settingFieldName: 'class',
                formFieldname: 'class'
            },
            {
                settingFieldName: 'preferrredvendor',
                formFieldname: 'preferrredvendor'
            },
            {
                settingFieldName: 'incomeaccount',
                formFieldname: 'incomeaccount'
            },
            {
                settingFieldName: 'expenseaccount',
                formFieldname: 'expenseaccount'
            }
        ]
    },
    {
        label: 'Other 1',
        sectionCode: 'labels_service_other1',
        fields: []
    },
    {
        label: 'Other 2',
        sectionCode: 'labels_service_other2',
        fields: []
    },
    {
        label: 'Other 3',
        sectionCode: 'labels_service_other3',
        fields: []
    }
];

export const WF_NON_PRODUCT_UPDATE_FIELDS = [
    {
        label: "Non Inventory Items",
        sectionCode: "labels_nvinfo",
        fields: [
            {
                settingFieldName: 'variant',
                formFieldname: 'variant'
            },
            {
                settingFieldName: 'category',
                formFieldname: 'category'
            },
            {
                settingFieldName: 'uom',
                formFieldname: 'uom'
            },
            // {
            //     settingFieldName: 'cost',
            //     formFieldname: 'cost'
            // },
            {
                settingFieldName: 'saleprice',
                formFieldname: 'saleprice'
            },
            {
                settingFieldName: 'rate',
                formFieldname: 'rate'
            },
            {
                settingFieldName: 'class',
                formFieldname: 'class'
            },
            {
                settingFieldName: 'preferrredvendor',
                formFieldname: 'preferrredvendor'
            },
            {
                settingFieldName: 'incomeaccount',
                formFieldname: 'incomeaccount'
            },
            {
                settingFieldName: 'expenseaccount',
                formFieldname: 'expenseaccount'
            }
        ]
    },
    {
        label: 'Other 1',
        sectionCode: 'labels_noninven_other1',
        fields: []
    },
    {
        label: 'Other 2',
        sectionCode: 'labels_noninven_other2',
        fields: []
    },
    {
        label: 'Other 3',
        sectionCode: 'labels_noninven_other3',
        fields: []
    }
];

export const WF_BUNDLE_PRODUCT_UPDATE_FIELDS = [
    {
        label: "Bundle Items",
        sectionCode: "labels_bundle",
        fields: [
            {
                settingFieldName: 'variant',
                formFieldname: 'variant'
            },
            {
                settingFieldName: 'category',
                formFieldname: 'category'
            },
            {
                settingFieldName: 'uom',
                formFieldname: 'uom'
            }
        ]
    },
    {
        label: 'Other 1',
        sectionCode: 'labels_bundle_other1',
        fields: []
    },
    {
        label: 'Other 2',
        sectionCode: 'labels_bundle_other2',
        fields: []
    },
    {
        label: 'Other 3',
        sectionCode: 'labels_bundle_other3',
        fields: []
    }
];

export const WF_KIT_PRODUCT_UPDATE_FIELDS = [
    {
        label: "Kit/Package Items",
        sectionCode: "labels_kitinfo",
        fields: [
            {
                settingFieldName: 'variant',
                formFieldname: 'variant'
            },
            {
                settingFieldName: 'category',
                formFieldname: 'category'
            },
            {
                settingFieldName: 'uom',
                formFieldname: 'uom'
            },
            {
                settingFieldName: 'salesprice',
                formFieldname: 'salesprice'
            },
            {
                settingFieldName: 'hsn',
                formFieldname: 'hsn'
            },
            {
                settingFieldName: 'width',
                formFieldname: 'width'
            },
            {
                settingFieldName: 'height',
                formFieldname: 'height'
            },
            {
                settingFieldName: 'lwhuom',
                formFieldname: 'lwhuom'
            },
            {
                settingFieldName: 'weight',
                formFieldname: 'weight'
            },
            {
                settingFieldName: 'wuom',
                formFieldname: 'wuom'
            },
        ]
    },
    {
        label: 'Other 1',
        sectionCode: 'labels_kit_other1',
        fields: []
    },
    {
        label: 'Other 2',
        sectionCode: 'labels_kit_other2',
        fields: []
    },
    {
        label: 'Other 3',
        sectionCode: 'labels_kit_other3',
        fields: []
    }
];
